import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { Response, IncoTerm, IncoTermSearchRequest } from '@core/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IncoTermService {
  constructor(private http: HttpClient) { }

  search(request: IncoTermSearchRequest): Observable<Response<IncoTerm[]>> {
    return this.http.post<Response<IncoTerm[]>>(environment.apiUrl + '/api/IncoTerm/Search', request);
  }
}
